import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { color } from '../../styles/mixins';

const wave = keyframes`
  0% {
      transform: translateX(-100%);
    }

    50% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(100%);
    }
`;

export const SkeletonHost = styled.span<{
  height: number;
  width: number;
  visible?: boolean;
}>`
  display: block;
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 4px;

  ${(props) =>
    props.visible &&
    css`
      &:before {
        content: '';
        position: absolute;
        background: ${color('gray20')};
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
      }

      &:after {
        content: '';
        position: absolute;
        z-index: 11;
        animation: 1.6s linear 0.5s infinite normal none running ${wave};
        background: linear-gradient(
          90deg,
          transparent,
          rgba(0, 0, 0, 0.04),
          transparent
        );
        transform: translateX(-100%);
        inset: 0px;
      }
    `}
`;

interface SkeletonProps {
  height: number;
  width: number;
  visible?: boolean;
}

export const Skeleton = ({ height, width, visible }: SkeletonProps) => {
  return <SkeletonHost height={height} width={width} visible={visible} />;
};
